<template>
  <div class="rec-swiper" :style="{ height: height + 'px' }">

    <div class="rec-adv-swiper1" :style="{ height: height + 'px', width: width + 'px' }">
      <div class="swiper-wrapper">
          <div class="swiper-slide" :style="{ height: height + 'px', width: width + 'px' }" v-for="(item, index) in dataSource1" :key="item.ID">
            <img :src="item.imageUrl || item.img" alt="" :data-index="index" />
          </div>
      </div>
      <div class="swiper-pagination rec-pagination1"></div>
    </div>

    <div class="rec-adv-swiper2" :style="{ height: height + 'px', width: width + 'px' }">
      <div class="swiper-wrapper">
          <div class="swiper-slide" :style="{ height: height + 'px', width: width + 'px' }" v-for="(item, index) in dataSource2" :key="item.ID">
            <img :src="item.imageUrl || item.img" alt="" :data-index="index" />
          </div>
      </div>
      <div class="swiper-pagination rec-pagination2"></div>
    </div>


    <whole-confirm ref="wholeConfirmRef"></whole-confirm>
  </div>
</template>

<script>
import {AdvertsType,AdvertsService, WinForm,Category} from '@digital-supply-chain/module'
import {ApiService,AdService,ChatService} from '@/service';

let swiper1 = null;
let swiper2 = null;

export default {
  data() {
    return {
      width: 0,
      height: 0,
      dataSource1: [],
      dataSource2: [],
    }
  },
  mounted() {
    this.width = parseInt((window.document.body.clientWidth - 80) / 2, 10);
    this.height = parseInt(this.width / 6, 10);

    this.queryAdverts();

    window.addEventListener('resize',() => {
      this.width = parseInt((window.document.body.clientWidth - 80) / 2, 10);
      this.height = parseInt(this.width / 6, 10);
      swiper1 && (swiper1.updateSize())
      swiper2 && (swiper2.updateSize())
    },false);
  },
  methods: {
    async queryAdverts() {
      const res = await AdvertsService.queryAdverts({
        type: AdvertsType.HomeSwiper,
        limit: 10,
      });
      let activityData = AdService.home_swiper_activity();
      let queryData = activityData.concat(res || []);
      if (queryData.length < 10) {
        queryData = queryData.concat(AdService.home_swiper_ads(1, (10 - queryData.length)));
      }
      const advs1 = [];
      const advs2 = [];
      queryData.forEach((item, index) => {
        item.imageUrl && (item.imageUrl = ApiService.ImageHost + item.imageUrl);
        item.image && (item.imageUrl = item.image);
        // 如果存在平台级的广告
        // if (activityData.length > 0) {
        //   if(item.compId != 0){
        //     advs2.push(item);
        //   }else{
        //     advs1.push(item);
        //   }
        // } else {
          if((index + 1) % 2 === 0 || item.targetUrl.startsWith("/company/home/39793")){
            advs2.push(item);
          }else{
            advs1.push(item);
          }
        // }
        
      })
      this.dataSource1 = advs1;
      this.dataSource2 = advs2;
      this.$nextTick(() => {
        this.swiperInit();
      })
    },
    swiperInit() {
      let _that = this;
      swiper1 = new window.Swiper('.rec-adv-swiper1', {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        pagination: {
          el: '.rec-pagination1',
        },
        on:{
          click: function(swiper, event){
            _that.advClick('dataSource1', event.target.dataset.index);
          },
        },
      });
      swiper2 = new window.Swiper('.rec-adv-swiper2', {
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        pagination: {
          el: '.rec-pagination2',
        },
        on:{
          click: function(swiper, event){
            _that.advClick('dataSource2', event.target.dataset.index);
          },
        },
      });
    },
    advClick(dataKey = '', index) {
      const datas = this[dataKey];
      console.log(datas, 'datas',dataKey)
      const adv = datas[Number(index)];
      try{
        // 埋点
        const timeclick = new Date().toLocaleString();
        const comname = adv.compName || '';
        // 易分析埋点
        _yfx_trackdata.push(['event','智搜广告点击',comname]);
      }catch(err) {}
    
      if (adv.activityId) {
        if (adv.activityId == 1) {
          this.$parent.joinInOpen();
        }
        if (adv.activityId == 2) {
          this.$refs.wholeConfirmRef.open({
              width: '470px',
              // showCancel: true,
              showOther: true,
              // cancelType: 'primary',
              // cancelText: '下载企业版',
              confirmText: '下载大工程师企业版及操作说明',
              otherText: '联系服务专员',
              content: '大工程师（企业版）是专为企业用户提供的工程师内部资源协同工作平台，除包含全部个人版功能外，还可以通过自己上传自用系列化模型的方式，构建自己的企标件库，方便内部共享使用。同时，追加了组织架构管理功能，可以设置企业内部专用供应链，保护企业常用资源。',
              cancel: () => {
                // WinForm.md.openUrl('https://down.global-dsc.cn/Release/bige-comp/BigEEInstall.exe');
              },
              confirm: () => {
                WinForm.md.openUrl('https://kyb-pack.oss-cn-hangzhou.aliyuncs.com/Release/kyb/dgcs.zip');
                // WinForm.md.openUrl(`${ApiService.OssHzHost}/jrzz/home_ad/企业版大工程师使用教程20230405.pdf`);
              },
              other: () => {
                ChatService.StartRecent(Category.User, 817)
              }

          })
        }
        return false;
      }
      if (adv.outUrl) {
        WinForm.md.openUrl(adv.outUrl);
        return false;
      }
      AdvertsService.openAdvertInfo(adv.advId, adv.targetUrl);
      // OpenService.openCompDetail(adv.id);
    }
  },
}
</script>

<style lang="less" scoped>
  .rec-swiper{
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 8px;
    z-index: 99;
    display: flex;
    justify-content: space-between;
    padding: 0 35px;
    &>div{
      overflow: hidden;
      position: relative;
    }
  }
  .swiper-slide{
    background-color: #ccc;
    cursor: pointer;
    text-align: center;
    /deep/ img{
      height: 100%;
      object-fit: contain;
    }
  }
  .swiper-pagination{
    text-align: right;
    padding-right: 10px;
    /deep/ .swiper-pagination-bullet-active{
      background-color: #ffffff;
    }
  }
</style>
